import React from 'react';
import { StanButton } from '@/components';
import { useUser } from '@/queries/useUser';
import { createIconElement } from '@/lib';
import _StanLogo from '@/assets/images/stan-logo.svg';
import IcClose from '@/assets/icons/ic-x-close.svg';

const StanLogo = createIconElement(_StanLogo, {
    className: 'size-8',
    removeFill: false,
});

interface CancellationModalWrapperProps {
    isOpen: boolean;
    children: React.ReactNode;
    showNav?: boolean;
    onClose?: () => void;
    centered?: boolean;
}

export const CancellationModalWrapper = ({
    isOpen,
    children,
    showNav = true,
    onClose,
    centered = false,
}: CancellationModalWrapperProps) => {
    const { user } = useUser();
    const username = user?.username || '';

    if (!isOpen) {
        return null;
    }

    return (
        <div
            className={`bg-bg-canvas z-overlay-content fixed inset-0 flex transition-opacity ${
                isOpen ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0'
            }`}
        >
            <div
                className={`relative flex h-full w-full flex-col overflow-hidden transition-all ${
                    isOpen ? 'scale-100 opacity-100' : 'scale-95 opacity-0'
                }`}
            >
                {/* Navigation with logo, username, and optional close button */}
                {showNav && (
                    <div className='flex items-center justify-between px-6 py-2'>
                        <div className='flex items-center gap-3'>
                            {StanLogo}
                            {username && <span className='text-body-1-bold text-text-primary'>@{username}</span>}
                        </div>
                        {onClose && (
                            <div className='flex items-center'>
                                <StanButton
                                    name='close-cancellation-modal'
                                    variant='ghost'
                                    onClick={onClose}
                                    icon={IcClose}
                                />
                            </div>
                        )}
                    </div>
                )}

                {/* Content */}
                {centered ? (
                    <div className='flex flex-1 items-center justify-center overflow-hidden'>
                        <div className='w-full max-w-lg p-6'>{children}</div>
                    </div>
                ) : (
                    <div className='flex flex-1 justify-center overflow-hidden'>
                        <div className='w-full max-w-lg overflow-y-auto px-6 pb-6'>{children}</div>
                    </div>
                )}
            </div>
        </div>
    );
};
